import { render } from "./About.vue?vue&type=template&id=74a4b1c6"
const script = {}
script.render = render

export default script